module.exports = __webpack_public_path__ + "13244bd99451605c61b32c9617162c1f.woff2";


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/themes/fonts/National2Web-Regular.woff2
// module id = 2512
// module chunks = 17